import { DataSource, Label, Layout, Panel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutLocationToProspect extends Layout {
    labelAssignDefaults: Label;
    labelRecordCount: Label;
    labelSelectedRecords: Label;
    panel1: Panel;
    sourceLocation: DataSource;
    sourcePreviewLocToProspect: DataSource;
    sourceProspect: DataSource;
    tableLocationsCovert: Table;
    textboxIntervalDays: Textbox;
    textboxMarketingPlan: Textbox;
    textboxOperationsUser: Textbox;
    textboxProspectType: Textbox;
    textboxReccuring: Textbox;
    textboxSalesStatus: Textbox;
    textboxSalesperson: Textbox;
    textboxStartDate: Textbox;
}
